<template>
  <div class="packs-redesign">
    <div class="packs-redesign__texts">
      <h2 class="packs-redesign__title">
        Линейка сигарет <strong>Mevius</strong> в&nbsp;выдвижной пачке
      </h2>
      <p class="packs-redesign__text">
        Уважаемый потребитель, информируем Вас о&nbsp;том, что в&nbsp;Марте 2025 в&nbsp;продажу поступили сигареты Mevius Sky Blue, выдвижная пачка и&nbsp;Mevius Wind Blue, выдвижная пачка в&nbsp;обновленном дизайне упаковки.
      </p>

      <p class="packs-redesign__text packs-redesign__text_emphasized">
        Вкус и&nbsp;качество сигарет остались неизменными.
      </p>
    </div>

    <div class="packs-redesign__packs">
      <div class="packs-redesign__pack">
        <div class="packs-redesign__image">
          <img src="../assets/i/packs-redesign/mevius-sky-blue.jpg" alt="" width="206" height="251">
        </div>
        <div class="packs-redesign__caption">
          <strong>Mevius Sky Blue,</strong> выдвижная пачка
        </div>
        <router-link :to="{ path: '/products/ssb-sky-blue' }" @click.native="close">
          <div class="packs-redesign__button">
            <span>Узнать больше</span>
          </div>
        </router-link>
      </div>
      <div class="packs-redesign__pack">
        <div class="packs-redesign__image">
          <img src="../assets/i/packs-redesign/mevius-wind-blue.jpg" alt=""  width="206" height="251">
        </div>
        <div class="packs-redesign__caption">
          <strong>Mevius Wind Blue,</strong> выдвижная пачка
        </div>
        <router-link :to="{ path: '/products/ssb-wind-blue' }" @click.native="close">
          <div class="packs-redesign__button">
            <span>Узнать больше</span>
          </div>
        </router-link>
      </div>
    </div>

    <div class="packs-redesign__features">
      <div class="packs-redesign__feature packs-redesign__feature_format">
        <img src="../assets/i/packs-redesign/feature-format.png" alt=""  width="51.5" height="51">
        Регулярный формат сигарет
      </div>
      <div class="packs-redesign__feature packs-redesign__feature_filter">
        <img src="../assets/i/packs-redesign/feature-filter.png" alt=""  width="51.5" height="51">
        Угольный фильтр
      </div>
      <div class="packs-redesign__feature packs-redesign__feature_japan">
        <img src="../assets/i/packs-redesign/feature-japan.png" alt=""  width="51.5" height="51">
        Табачная мешка разработана в&nbsp;Японии
      </div>
    </div>
    <div class="packs-redesign__footnote">
      Обращаем внимание, что в&nbsp;связи с&nbsp;Федеральным Законом №325-ФЗ от&nbsp;8&nbsp;Августа 2024&nbsp;года, сигареты Mevius будут выпускаться без&nbsp;специальной бумажной (акцизной) марки, а&nbsp;предупредительный рисунок о&nbsp;вреде курения на&nbsp;оборотной стороне пачки будет располагаться не&nbsp;в&nbsp;нижней, а&nbsp;в&nbsp;верхней части пачки.
    </div>

    <picture>
      <source srcset="../assets/i/packs-redesign/bg-mobile.jpg" media="(max-width: 500px)" />
      <source srcset="../assets/i/packs-redesign/bg-desktop.jpg" />
      <img src="../assets/i/packs-redesign/bg-desktop.jpg" alt="" class="packs-redesign__bg">
    </picture>

  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss">
@import "../scss/base/mixins";
@import "../scss/base/variables";

@mixin mobile {
  @media screen and (max-width: 500px) {
    @content;
  }
}

.modal-info {
  &_theme_packs-redesign {
    padding: 15px;
    .modal {
      overflow: hidden;
      -webkit-mask-image: -webkit-radial-gradient(white, black);
      max-width: 470px;
      padding: 28px 26px 0;

      @include mobile {
        padding: 25px 18px 0;
      }

      &__close {
        top: 10px;
        right: 10px;

        @include mobile {
          top: 13px;
          right: 13px;
        }

        svg {
          path {
            fill: $brand-color;
          }
        }
      }
    }
  }
}

.packs-redesign {
  font-family: "Montserrat", sans-serif;

  &__title {
    margin: 16px 0;
    @include first-and-last-child-zero-margin;

    font-size: 27px;
    text-transform: uppercase;
    font-weight: 400;
    line-height: 1.11;
    letter-spacing: .001em;

    @include mobile {
      margin: 24px 0;
      line-height: 1.14;
    }

    strong {
      font-weight: 600;
    }

    &::before {
      @include mobile {
        content: "";
        display: block;
        width: 30px;
        height: 15px;
        float: right;
      }
    }
  }

  &__text {
    margin: 10px 0;
    @include first-and-last-child-zero-margin;

    font-size: 13px;
    font-weight: 500;
    line-height: 1.23;

    @include mobile {
      margin: 20px 0;
      font-size: 14px;
    }

    &_emphasized {
      font-weight: 700;
      font-style: italic;
    }
  }

  &__packs {
    display: flex;
    justify-content: space-between;
    margin-top: 9px;

    @include mobile {
      margin-left: -3px;
      margin-right: -3px;
    }
  }

  &__pack {
    display: flex;
    flex-direction: column;
    width: calc(50% - 30px / 2);
    @include mobile {
      width: calc(50% - 19px / 2);
    }
    a {
      text-decoration: none;
    }
  }

  &__image {
    position:  relative;
    top: 1px;
    left: -2px;

    img {
      display: block;
      width: 106.186%;
      height: auto;
    }
  }

  &__caption {
    flex: 1;
    margin-top: 9px;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.15;
    letter-spacing: 0;
    @include mobile {
      margin-top: 16px;
      margin-bottom: 18px;
      font-size: 12px;
    }

    strong {
      font-weight: 600;
    }
  }

  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: blue;
    padding: 0 20px;
    text-transform: uppercase;
    color: $white-true;
    font-family: "DinPro", sans-serif;
    font-size: 8px;
    font-weight: 700;
    line-height: 1.2;
    background: linear-gradient(0deg, #073D8B 0%, #0C60D8 100%);
    min-height: 30px;
    border-radius: 15px;
    cursor: pointer;

    background-size: 100% 100%;
    background-position-y: 0;
    transition: background-size .3s, background-position-y .3s;

    @include hover {
      background-size: 100% 150%;

      &::after {
        animation: .5s packs-redesign-button-arrow;
      }
    }

    &:active {
      background-size: 100% 150%;
      background-position-y: 50%;
    }

    &::after {
      content: "";
      margin-left: 4px;
      width: 5px;
      height: 8px;
      background: url('data:image/svg+xml,<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(%23clip0_5625_249)"><path d="M1.125 1.24609L3.87891 4L1.125 6.75391" stroke="white" stroke-width="1.10156" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_5625_249"><rect width="5" height="8" fill="white"/></clipPath></defs></svg>') no-repeat;
    }

    span {
      margin-bottom: 1px;
    }
  }

  &__features {
    display: flex;
    margin-top: 15px;

    @include mobile {
      flex-direction: column;
      row-gap: 13px;
      margin-top: 23px;
    }
  }

  &__feature {
    flex: none;
    display: flex;
    align-items: center;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.15;

    @include mobile {
      line-height: 1.19;
    }

    &_format {
      width: 149px;
      @include mobile {
        width: auto;
        max-width: 184px;
      }
    }

    &_filter {
      width: 110px;
      @include mobile {
        width: auto;
        max-width: 140px;
      }
    }

    &_japan {
      width: 168px;
      @include mobile {
        width: auto;
        max-width: 236px;
      }
    }

    @include mobile {
      font-size: 14px;
    }

    img {
      width: 34.8px;
      height: auto;
      margin-right: 7px;

      @include mobile {
        width: 51.7px;
        margin-right: 10px;
      }
    }
  }

  &__footnote {
    margin-top: 16px;
    margin-bottom: 2px;
    font-size: 7px;
    font-weight: 500;
    line-height: 1.12;
    @include mobile {
      margin-top: 23px;
      margin-bottom: 21px;
      font-size: 6px;
      line-height: 1.17;
    }
  }

  &__bg {
    display: block;
    width: calc(100% + 28px * 2);
    margin-left: -28px;
    height: auto;

    @include mobile {
      width: calc(100% + 18px * 2);
      margin-left: -18px;
    }
  }

  @keyframes packs-redesign-button-arrow {
    0% {
      transform: translateX(0);
    }

    50% {
      transform: translateX(4px);
    }

    100% {
      transform: translateX(0);
    }
  }

}
</style>
